import React from "react";
import { AptPackage } from "../../../utils/api/apartmentRentalsAPI";
import { fmtAmount } from "./bookingPricing";

interface Props {
  matchedPackages: AptPackage[];
  applyPackage: boolean | null;
  selectedPackage: AptPackage | null;
  setApplyPackage: (v: boolean | null) => void;
  setSelectedPackage: (p: AptPackage | null) => void;
  totalPersons: number;
  nights: number;
  nightsTotal: number;
  currency?: string;
  t: (key: any) => any;
}

const PackagesBlock: React.FC<Props> = ({
  matchedPackages, applyPackage, selectedPackage, setApplyPackage, setSelectedPackage,
  totalPersons, nights, nightsTotal, currency, t,
}) => {
  if (matchedPackages.length === 0) return null;

  if (applyPackage === true && selectedPackage) {
    return (
      <div className="pab-pkg-banner pab-pkg-banner--applied">
        <div className="pab-pkg-banner__row">
          <div className="pab-pkg-banner__title">
            <span className="ic">🎁</span> {selectedPackage.name} — primijenjeno
          </div>
          <button type="button" className="pab-btn-ghost pab-btn-ghost--sm" onClick={() => { setApplyPackage(false); setSelectedPackage(null); }}>
            ✕ Skloni
          </button>
        </div>
        {selectedPackage.includes?.filter((i) => i.label).length > 0 && (
          <div className="pab-pkg-banner__chips">
            {selectedPackage.includes.filter((i) => i.label).map((inc, idx) => (
              <span key={idx} className="pab-chip pab-chip--ok">✓ {inc.label}</span>
            ))}
          </div>
        )}
      </div>
    );
  }

  if (applyPackage === false) {
    return (
      <div className="pab-pkg-banner pab-pkg-banner--declined">
        <span>
          🎁 {matchedPackages.length === 1 ? `"${matchedPackages[0].name}"` : `${matchedPackages.length} ${t("availableDeals")}`} {t("notApplied")}
        </span>
        <button type="button" className="pab-btn-ghost pab-btn-ghost--sm" onClick={() => setApplyPackage(null)}>
          {t("review")}
        </button>
      </div>
    );
  }

  return (
    <div className="pab-pkg-banner pab-pkg-banner--choice">
      <div className="pab-pkg-banner__title">
        <span className="ic">🎁</span> {matchedPackages.length === 1 ? t("availableDeal") : `${matchedPackages.length} ${t("availableDeals")}`}
      </div>
      <div className="pab-pkg-list">
        {matchedPackages.map((pkg) => {
          const tiers = pkg.pricingByPersons || [];
          let pkgPrice: number | null = null;
          if (tiers.length > 0) {
            const sorted = [...tiers].sort((a, b) => a.persons - b.persons);
            let best = sorted[0];
            for (const tier of sorted) { if (tier.persons <= totalPersons) best = tier; }
            pkgPrice = best.pricePerNight;
          }
          const discountedTotal = pkg.discountPercent != null
            ? Math.round(nightsTotal * (1 - pkg.discountPercent / 100))
            : null;

          return (
            <div key={pkg._id} className="pab-pkg-item">
              <div className="pab-pkg-item__row">
                <div>
                  <div className="pab-pkg-item__name">{pkg.name}</div>
                  {pkg.description && <div className="pab-pkg-item__desc">{pkg.description}</div>}
                </div>
                <button
                  type="button"
                  className="pab-btn-dark pab-btn-dark--sm"
                  onClick={() => { setSelectedPackage(pkg); setApplyPackage(true); }}
                >
                  {t("apply")}
                </button>
              </div>
              {pkgPrice != null && (
                <div className="pab-pkg-item__price">
                  {fmtAmount(pkgPrice, pkg.currency)}{t("perNightTotal")} {fmtAmount(pkgPrice * nights, pkg.currency)}
                </div>
              )}
              {discountedTotal != null && (
                <div className="pab-pkg-item__price">
                  −{pkg.discountPercent}% · {t("total").toLowerCase()} {fmtAmount(discountedTotal, pkg.currency ?? currency)}
                </div>
              )}
              {pkg.includes?.filter((i) => i.label).length > 0 && (
                <div className="pab-pkg-banner__chips">
                  {pkg.includes.filter((i) => i.label).map((inc, idx) => (
                    <span key={idx} className="pab-chip pab-chip--accent">✓ {inc.label}</span>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <button type="button" className="pab-btn-outline" style={{ width: "100%" }} onClick={() => setApplyPackage(false)}>
        {t("noThanksBookWithout")}
      </button>
    </div>
  );
};

export default PackagesBlock;
